export default __webpack_public_path__ + "static/3-year-37d54531bd3638cd3b6c7eeb041ceb02.svg";